import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LayoutHeader from '../../layout/LayoutHeader';
import { verifyEmailOTP, sendOtpToEmailThunk } from '../../store/auth/authThunk';
import { clearAlerts } from '../../store/alert/alertSlice';
import DizeeInput from '../../components/DizeeComponent/DizeeInput';

export default function TeamMemberVerifyOldEmail() {
    const [code, setCode] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { email } = useSelector((state) => state.user.userArticle);

    const maskEmail = (email) => {
        if (!email) return '';
        const [local, domain] = email.split('@');
        const maskedLocal = local.length > 2 
            ? local[0] + '*'.repeat(local.length - 2) + local[local.length - 1]
            : local[0] + '*';
        return `${maskedLocal}@${domain}`;
    }

    useEffect(() => {
        if (code.length === 6) {
            dispatch(clearAlerts())
            dispatch(verifyEmailOTP({ email, code })).then((res) => {
                if (res.payload.status === 200) {
                    navigate("/team-member/new-email");
                }
            });
        }
    }, [code]);

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className="px-4 my-[50px] flex w-full justify-between">
                    <p className="text-white">Change email address</p>
                    <div className='flex gap-[20px]'>
                        <p onClick={() => navigate('/team-member/advanced')} className='text-white cursor-pointer'>Go back</p>
                    </div>
                </div>

                <div className="w-full px-4">
                    <div className="flex flex-col justify-between">
                        <div className="py-6 flex flex-col gap-y-6">
                            <div className="text-white">
                                Code has been sent to {maskEmail(email)}
                            </div>
                            <div className="flex flex-col gap-y-[40px]">
                                <DizeeInput
                                    placeholder={"Enter the code"}
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                                <div className="flex justify-start w-full gap-[43px]">
                                    <button 
                                        className="text-white cursor-pointer text-[12px] h-[18px] leading-[18px]"
                                        onClick={() => {
                                            if (code.length === 6) {
                                                dispatch(clearAlerts())
                                                dispatch(verifyEmailOTP({ email, code }))
                                            }
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button 
                                        className="text-white cursor-pointer text-[12px] h-[18px] leading-[18px]"
                                        onClick={() => dispatch(sendOtpToEmailThunk(email))}
                                    >
                                        Resend code
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
} 